import { AlternateIdentifier } from 'domain';

export const initState = {
    list: [],
    current: null,
    isLoading: false,
    hasFailed: false
};

export default function alternateIdentifierReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_ALTERNATE_IDENTIFIERS_PENDING':
        case 'GET_ALTERNATE_IDENTIFIER_PENDING':
            return { ...state, isLoading: true, hasFailed: false };

        case 'LIST_ALTERNATE_IDENTIFIERS_REJECTED':
        case 'GET_ALTERNATE_IDENTIFIER_REJECTED':
            return { ...state, isLoading: false, hasFailed: true };

        case 'LIST_ALTERNATE_IDENTIFIERS_FULFILLED':
            return {
                ...state,
                list: payload.map(item => new AlternateIdentifier(item)),
                isLoading: false,
                hasFailed: false
            };

        case 'GET_ALTERNATE_IDENTIFIER_FULFILLED':
            return {
                ...state,
                current: new AlternateIdentifier(payload),
                isLoading: false,
                hasFailed: false
            };

        default:
            return state;
    }
}